export const TICKET_MESSAGES_REFRESH = "sigichat:ticket-messages:refresh";
export const TICKET_SIDEBAR_UPDATE = "sigichat:ticket-sidebar:update";

export const notifyTicketSidebarUpdate = (payload = {}) => {
  window.dispatchEvent(
    new CustomEvent(TICKET_SIDEBAR_UPDATE, {
      detail: payload,
    })
  );
};

export const notifyTicketMessagesRefresh = (ticketUuid, extra = {}) => {
  if (ticketUuid) {
    window.dispatchEvent(
      new CustomEvent(TICKET_MESSAGES_REFRESH, {
        detail: { ticketUuid, ...extra },
      })
    );
  }

  notifyTicketSidebarUpdate({ ticketUuid, ...extra });
};
